import {StyleSheet} from "aphrodite";

import {addStyle, type StyleType} from "@khanacademy/wonder-blocks-core";

interface Props {
    children: React.ReactNode;

    /* CSS styles for the container. */
    containerStyle?: StyleType;

    /* CSS styles for the main content. */
    mainContentStyle?: StyleType;

    /* A custom header component to render at the top of the page. */
    header?: React.ReactNode;
}

const StyledDiv = addStyle("div");
const StyledMain = addStyle("main");

export default function BasicPageTemplate({
    containerStyle,
    mainContentStyle,
    children,
    header,
}: Props) {
    return (
        <StyledDiv style={containerStyle ?? styles.container}>
            {header}
            <StyledMain
                style={mainContentStyle ?? styles.mainContent}
                id="main-content"
                tabIndex={-1}
            >
                {children}
            </StyledMain>
        </StyledDiv>
    );
}

const styles = StyleSheet.create({
    container: {
        display: "flex",
        flexDirection: "column",
        minBlockSize: "100%",
    },

    mainContent: {
        flex: "none",
        // NOTE(john): We set the min-height here to be 100vh so that we can push down the
        // footer to below the page fold, preventing as big of a jarring jump when the page
        // loads.
        minBlockSize: "100vh",
    },
});
